export default __webpack_public_path__ + "static/media/creator-account-type.be47b345.png";